import { ListChecks } from 'lucide-react';
import { useTranslation } from '../../lib/i18n';
import { useGenericBi } from '../../lib/use-generic-bi';
import { useOpenSideChat } from '../../lib/use-open-side-chat';
import { useOpenSetupQuestions } from '../../lib/suggested-tasks';
import { Button } from './ui';
import styles from './SetupQuestionsControl.module.css';

// "Complete your setup": the header entry to the genome's open setup questions (symphony-bff
// `ListSuggestedTasksResponse.open_setup_questions`). It replaced the `complete-your-setup` dashboard card,
// which the genome no longer writes: the questions are about the whole account, so they are a header
// control on every Space (not the Home), never a widget. Hidden while there are no open questions.
// Shared 1:1 with iOS `SetupQuestionsButton` and Android `SetupQuestionsButton`: same keys, same prompt.
export function SetupQuestionsControl({ pageName, workspaceId }: { pageName: string; workspaceId?: string }) {
  const open = useOpenSetupQuestions();
  const { t } = useTranslation();
  const { logPageClickBi } = useGenericBi();
  const openSideChat = useOpenSideChat();
  if (open <= 0) return null;
  return (
    <Button
      variant="outlined"
      size="small"
      className={styles.control}
      startIcon={<ListChecks size={16} aria-hidden />}
      aria-label={t(open === 1 ? 'setupQuestions.a11y.one' : 'setupQuestions.a11y.other', { count: open })}
      data-testid="setupQuestionsControl"
      onClick={() => {
        logPageClickBi({ page_name: pageName, button_name: 'complete_your_setup' });
        // The same message the old card's button sent, so the agent runs the same interview.
        openSideChat({ kind: 'new', message: t('setupQuestions.prompt'), workspaceId });
      }}
    >
      {t('setupQuestions.label', { count: open })}
    </Button>
  );
}
